module.exports = __webpack_public_path__ + "img/phoneus.4088ddc3.jpg";